// extracted by mini-css-extract-plugin
export var content = "TextInCircle-module--content--fecb1";
export var wrapper = "TextInCircle-module--wrapper--954ae";